import * as React from 'react';
import { FacebookProvider, Like } from 'react-facebook';

const LikePage = () => {
	return (
		<div className="blockSidebar mb-4">
		{/*	<FacebookProvider appId="525039007912592">
				<Like href="http://www.facebook.com" colorScheme="dark" showFaces share />
			</FacebookProvider>*/}
		</div>
	);
};

export default LikePage;



// WEBPACK FOOTER //
// ./src/containers/component/LikePage.tsx